import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { SharedModule } from '@shared';
import { MaterialModule } from '@app/material.module';
import { HeaderComponent } from './header.component';
import { HomeDialogComponent } from './home-dialog.component';
import { RouterModule } from '@angular/router';
import { FooterModule } from '@app/shell/footer/footer.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    FlexLayoutModule,
    MaterialModule,
    FooterModule,
    RouterModule,
  ],
  exports: [HeaderComponent],
  declarations: [HeaderComponent, HomeDialogComponent],
})
export class HeaderModule {}
